import React, { BaseSyntheticEvent, Dispatch, SetStateAction } from 'react';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/modal';
import { Button } from '@landsvirkjun/react.common';
import { Text as TextComponent } from '@chakra-ui/layout';
import { useNavigate } from 'react-router';

type CloseFormModalProps = {
  isOpen: boolean;
  onClose: () => void;
  isSubmitting: boolean;
  handleSubmit: (
    e?: BaseSyntheticEvent<object, any, any> | undefined
  ) => Promise<void>;
  setSkipValidation: Dispatch<SetStateAction<boolean>>;
};

export const CloseFormModal = ({
  isOpen,
  onClose,
  isSubmitting,
  handleSubmit,
  setSkipValidation,
}: CloseFormModalProps): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onCloseComplete={(): void => setSkipValidation(false)}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Hætta við stofnun ferðabeiðnar</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <TextComponent mb={3}>
            Ertu viss um að þú viljir hætta við beiðnina?
          </TextComponent>
          <TextComponent>
            {`Þú getur geymt
            beiðnina og haldið áfram með hana síðar með því að ýta á "Geyma og
            loka" fyrir neðan.`}
          </TextComponent>
        </ModalBody>

        <ModalFooter>
          <Button variant="warning" mr={3} onClick={(): void => navigate(-1)}>
            Hætta við
          </Button>
          <Button
            type="submit"
            variant="primary"
            name="save-draft"
            isLoading={isSubmitting}
            loadingText="Augnablik..."
            onClick={(event): Promise<void> => handleSubmit(event)}
          >
            Geyma og loka
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
